import PageHeader from 'components/common/PageHeader';
import React from 'react';
import { Accordion, Card } from 'react-bootstrap';
import FaqAccordionItem from './FaqAccordionItem';
import {
  faqAccount,
  faqBonusMalus,
  faqClasse,
  faqGameplay,
  faqProfessoriStudenti,
  faqSquadre
} from './faqs';
import { titler } from 'helpers/titler';

const Faq = () => {
  titler('Domande Frequenti');
  return (
    <>
      <PageHeader
        title="Domande Frequenti"
        description="In questa sezione troverai la soluzione a ogni tuo dubbio su FantaClasse, per giocare come un pro fin dal primo giorno! 💡🏅"
        className="mb-3"
      />

      <Card className="mb-3">
        <Card.Body>
          <h4 className="fs-8 text-center mb-3">Profilo</h4>
          <Accordion
            id="accordionFaq"
            className="border rounded overflow-hidden"
          >
            {faqAccount.map((faq, index) => (
              <FaqAccordionItem
                key={faq.id}
                faq={faq}
                isFirst={index === 0}
                isLast={index === faqAccount.length - 1}
              />
            ))}
          </Accordion>
        </Card.Body>
      </Card>
      <Card className="mb-3">
        <Card.Body>
          <h4 className="fs-8 text-center mb-3">Classe</h4>
          <Accordion
            id="accordionFaq"
            className="border rounded overflow-hidden"
          >
            {faqClasse.map((faq, index) => (
              <FaqAccordionItem
                key={faq.id}
                faq={faq}
                isFirst={index === 0}
                isLast={index === faqClasse.length - 1}
              />
            ))}
          </Accordion>
        </Card.Body>
      </Card>
      <Card className="mb-3">
        <Card.Body>
          <h4 className="fs-8 text-center mb-3">Bonus e Malus</h4>
          <Accordion
            id="accordionFaq"
            className="border rounded overflow-hidden"
          >
            {faqBonusMalus.map((faq, index) => (
              <FaqAccordionItem
                key={faq.id}
                faq={faq}
                isFirst={index === 0}
                isLast={index === faqBonusMalus.length - 1}
              />
            ))}
          </Accordion>
        </Card.Body>
      </Card>
      <Card className="mb-3">
        <Card.Body>
          <h4 className="fs-8 text-center mb-3">Professori e Studenti</h4>
          <Accordion
            id="accordionFaq"
            className="border rounded overflow-hidden"
          >
            {faqProfessoriStudenti.map((faq, index) => (
              <FaqAccordionItem
                key={faq.id}
                faq={faq}
                isFirst={index === 0}
                isLast={index === faqProfessoriStudenti.length - 1}
              />
            ))}
          </Accordion>
        </Card.Body>
      </Card>
      <Card className="mb-3">
        <Card.Body>
          <h4 className="fs-8 text-center mb-3">Squadre</h4>
          <Accordion
            id="accordionFaq"
            className="border rounded overflow-hidden"
          >
            {faqSquadre.map((faq, index) => (
              <FaqAccordionItem
                key={faq.id}
                faq={faq}
                isFirst={index === 0}
                isLast={index === faqSquadre.length - 1}
              />
            ))}
          </Accordion>
        </Card.Body>
      </Card>
      <Card className="mb-3">
        <Card.Body>
          <h4 className=" fs-8 text-center mb-3">Gameplay</h4>
          <Accordion
            id="accordionFaq"
            className="border rounded overflow-hidden"
          >
            {faqGameplay.map((faq, index) => (
              <FaqAccordionItem
                key={faq.id}
                faq={faq}
                isFirst={index === 0}
                isLast={index === faqGameplay.length - 1}
              />
            ))}
          </Accordion>
        </Card.Body>
      </Card>
    </>
  );
};

export default Faq;
